<template>
  <!-- 推荐视频 -->
  <div class="detrecomaudio">
    <div class="zjbthea between">
      <div>推荐语音解答</div>
      <div class="mo" @click="toaudio()">更多></div>
    </div>
    <div class="tjlist">
      <div class="tjitem" v-for="(item,index) in list" :key="index" @click="tojump(item)">
        <div class="tjaudiobt ellipsis">
          {{item.title}}
        </div>
        <div class="tjaobom flex_start">
          <div class="tjlawcov">
            <img :src="item.preview_pic" alt="" />
          </div>
          <div class="rigtext">
            <div class="tjlawname">{{item.true_name}}</div>
            <div class="tjyy between">
              <div class="yuyin flex_start">
                <img src="~assets/claimdet/audioplay.png" />{{item.duration}}
              </div>
              <div>{{item.view_num}}人收听</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
  props: ["list"],
  methods:{
    toaudio(){
      this.$router.push({path:'/laws/audioclaim'})
    },
    
    tojump(item) {
      this.$router.push({
        path: "/laws/audioimdet",
        query: {
          audioinId: item.id,
        },
      });
    },
  }
};
</script>

<style lang="scss" scope>
.detrecomaudio {
  width: 100%;
  padding: 10px 10px 0;
  .zjbthea {
    padding: 14px 20px 14px 10px;
    font-size: 18px;
    color: #333333;
    .mo {
      font-size: 14px;
      color: #999999;
      cursor: pointer;
    }
  }
  .tjlist {
    .tjitem {
      padding: 20px 10px;
      align-items: flex-start;
      cursor: pointer;
      border-top: 1px solid #eee;
      .tjaudiobt {
        font-size: 16px;
        color: #333333;
      }
      .tjaobom {
        align-items: flex-start;
        margin-top: 14px;
        .tjlawcov {
          margin-right: 14px;
          img {
            width: 49px;
            height: 49px;
            border-radius: 3px;
          }
        }
        .rigtext {
          width: 100%;
          .tjlawname {
            font-size: 14px;
            color: #333333;
          }
          .tjyy {
            margin-top: 6px;
            font-size: 12px;
            color: #aaaaaa;
            width: 100%;
            .yuyin {
              width: 90px;
              height: 24px;
              background: #eeeeee;
              border-radius: 3px;
              padding-left: 5px;
              img {
                margin-right: 5px;
                width: 15px;
                height: 15px;
              }
            }
          }
        }
      }

      &:hover {
        .tjaudiobt {
          color: #0465ea;
        }
      }
    }
  }
}
</style>